import type { App } from "vue";
import type { AxiosResponse } from "axios";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/services/JwtService";
import { User } from "./auth"; 

/**
 * @description service to call HTTP request via Axios
 */
class ApiService {
  static request(arg0: { url: string; method: string; data: { userId: string; validationQueueId: string; }; }) {
      throw new Error("Method not implemented.");
  }
  /**
   * @description property to share vue instance
   */
  public static vueInstance: App;

  /**
   * @description initialize vue axios
   */
  public static init(app: App<Element>) {
    ApiService.vueInstance = app;

    // Init Axios une seule fois
    ApiService.vueInstance.use(VueAxios, axios);
    // ** const httpsAgent = new https.Agent({
    //  rejectUnauthorized: false, 
    // });

    // ApiService.vueInstance.axios.defaults.httpsAgent = httpsAgent;
    // ApiService.vueInstance.axios.defaults.baseURL ='http://localhost:3005/api';
    ApiService.vueInstance.axios.defaults.baseURL ='https://bescbackend.romasprojet.com/api';

    ApiService.vueInstance.axios.defaults.headers.common["Accept"] ="application/json";
    ApiService.vueInstance.axios.defaults.headers.common["Content-Type"] ="application/json";
    ApiService.vueInstance.use(VueAxios, axios);
  } 

  /**
   * @description set the default HTTP request headers
   */
  public static setHeader(): void {
    const token = JwtService.getToken();
    console.log(token, "tokentokentokentokentoken")

    ApiService.vueInstance.axios.defaults.headers.common["Authorization"] =
      token ? `Bearer ${token}` : "";

    ApiService.vueInstance.axios.defaults.headers.common["Accept"] = "application/json";

    console.log(
      ApiService.vueInstance.axios.defaults.headers,
      "ApiService.vueInstance.axios.defaults.headers"
    );
  }

  /**
   * @description send the GET HTTP request
   */
  public static query(resource: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.get(resource, params);
  }

  /**
   * @description GET request for files (PDF, images, etc.)
   */
  public static getFile(resource: string): Promise<AxiosResponse<any>> {
    return ApiService.vueInstance.axios.get(resource, {
      responseType: "blob",
    });
  }

  /**
   * @description GET by resource and slug
   */
  public static get(resource: string, slug = ""): Promise<AxiosResponse> {
  const endpoint = slug ? `${resource}/${slug}` : resource;
  return ApiService.vueInstance.axios.get(endpoint);
}

  /**
   * @description POST request
   */
  public static post(resource: string, params: any, config?: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.post(`${resource}`, params, config);
  }

  /**
   * @description POST with multipart/form-data
   */
  public static postWithFile(resource: string, params: any): Promise<AxiosResponse> {
    console.log("=== ApiService.postWithFile ===");
    console.log("Resource:", resource);
    console.log("Params type:", typeof params);
    console.log("Is FormData:", params instanceof FormData);

    if (params instanceof FormData) {
      console.log("FormData contents in ApiService:");
      for (const [key, value] of params.entries()) {
        console.log(`  ${key}:`, value);
      }
    }

    const token = JwtService.getToken();
    console.log("Token utilisé:", token ? "✅ Token présent" : "❌ Pas de token");

    return ApiService.vueInstance.axios.post(`${resource}`, params, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "*/*",
        Authorization: token ? `bearer ${token}` : "",
      },
    });
  }

  /**
   * @description UPDATE (PUT) with slug
   */
  public static update(resource: string, slug: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.put(`${resource}/${slug}`, params);
  }

  /**
   * @description PUT request
   */
  public static put(resource: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.put(`${resource}`, params);
  }

  /**
   * @description DELETE request
   */
  public static delete(resource: string): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.delete(resource);
  }

  /**
 * @description PATCH request
 */
public static patch(resource: string,params?: any,config?: any): Promise<AxiosResponse> {
  return ApiService.vueInstance.axios.patch(resource, params, config);
}


}




export default ApiService;
